import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  hmr: false,
  apiUrl: 'https://pitch-api.qa.gls.wmgapps.dev/api/',
  featureFlags: {},
};
